import { render, staticRenderFns } from "./task-video-call.vue?vue&type=template&id=a6db4c94&scoped=true&"
import script from "./task-video-call.vue?vue&type=script&lang=js&"
export * from "./task-video-call.vue?vue&type=script&lang=js&"
import style0 from "./task-video-call.vue?vue&type=style&index=0&id=a6db4c94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6db4c94",
  null
  
)

export default component.exports